var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.75V0.75M9.75 11.75L4.75 7.16667M9.75 11.75L14.75 7.16667M18.75 11.75V15.4167C18.75 15.9029 18.5393 16.3692 18.1642 16.713C17.7891 17.0568 17.2804 17.25 16.75 17.25H2.75C2.21957 17.25 1.71086 17.0568 1.33579 16.713C0.960714 16.3692 0.75 15.9029 0.75 15.4167V11.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadData);
export default __webpack_public_path__ + "static/media/downloadData.49b1a72c8a5dd7a0c1393975851c3552.svg";
export { ForwardRef as ReactComponent };